
import { Button } from "@/components/ui/button";
import { Clock, Calendar } from "lucide-react";

export default function Blog() {
  // Sample blog data - in a real app, this would come from an API
  const blogPosts = [
    {
      id: 1,
      title: "How AI is Transforming Technical Hiring",
      excerpt: "Explore how artificial intelligence is revolutionizing the way companies assess and hire technical talent.",
      date: "May 5, 2024",
      readTime: "5 min read",
      image: "https://images.unsplash.com/photo-1488590528505-98d2b5aba04b",
      author: "Jane Smith"
    },
    {
      id: 2,
      title: "5 Ways to Improve Your Technical Assessment Process",
      excerpt: "Discover proven strategies to enhance your technical assessment methodology and attract top talent.",
      date: "April 28, 2024",
      readTime: "8 min read",
      image: "https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d",
      author: "John Doe"
    },
    {
      id: 3,
      title: "The Rise of Video Interviews in Technical Hiring",
      excerpt: "Learn why video assessments are becoming essential in modern technical hiring pipelines.",
      date: "April 20, 2024",
      readTime: "6 min read",
      image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6",
      author: "Alex Johnson"
    },
  ];
  
  return (
    <div className="py-24 px-4">
      <div className="container mx-auto max-w-5xl">
        <h1 className="text-3xl md:text-4xl font-bold text-center mb-4 text-foreground">Testera Blog</h1>
        <p className="text-center text-muted-foreground max-w-2xl mx-auto mb-12">
          Insights, tips, and trends to help you hire better with technology-driven assessments.
        </p>
        
        <div className="flex flex-col gap-8 mt-12">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-foreground">Coming Soon!</h2>
            <p className="text-muted-foreground mt-2">
              We're working on amazing content to help you improve your hiring process.
              Check back soon or subscribe to our newsletter to be notified when new articles are published.
            </p>
            
            <div className="mt-8 max-w-md mx-auto">
              <div className="flex flex-col sm:flex-row gap-2">
                <input 
                  type="email" 
                  placeholder="Your email address" 
                  className="flex-grow px-4 py-2 rounded-sm border border-border bg-background"
                />
                <Button className="bg-secondary hover:bg-secondary-hover text-secondary-foreground">
                  Subscribe
                </Button>
              </div>
            </div>
          </div>
          
          {/* Sample blog post previews - these will be displayed once the blog is live */}
          <div className="hidden grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-12">
            {blogPosts.map((post) => (
              <div key={post.id} className="bg-card rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-shadow">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={post.image} 
                    alt={post.title} 
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold mb-2 text-foreground">{post.title}</h3>
                  <p className="text-muted-foreground mb-4">{post.excerpt}</p>
                  <div className="flex items-center justify-between text-sm text-muted-foreground">
                    <div className="flex items-center gap-1">
                      <Calendar className="h-4 w-4" />
                      <span>{post.date}</span>
                    </div>
                    <div className="flex items-center gap-1">
                      <Clock className="h-4 w-4" />
                      <span>{post.readTime}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
